import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <div className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Wycena wykonania strony oraz kampanii reklamowych</h1>
          <p>Kompleksowe rozwiązania dla firm z sektora finansowego - od stron internetowych po kampanie reklamowe</p>
          <div className="hero-buttons">
            <Link to="/website-structure" className="btn btn-primary">
              Struktura Strony
            </Link>
            <Link to="/website-pricing" className="btn btn-secondary">
              Wycena Strony
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;